/**
 * AuthGuard — оборачивает приватные страницы.
 * Если нет токена — редирект на /login-required.
 */

import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { tokenStorage } from '../lib/token-storage';

export function AuthGuard({ children }: { children: ReactNode }) {
  if (tokenStorage.getAccessToken() === null) {
    return <Navigate to="/login-required" replace />;
  }
  return <>{children}</>;
}
